import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import ArtifactForm from './ArtifactForm';
// import { initialValues  } from './initialValues-testing';
import { showArtifactApi, updateArtifactApi, clearEditedArtifact } from './artifactSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { pictureAttributeNames } from './initialValue';
import uploadImage from '~/api/uploadImage';

function ArtifactUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.itemSaga.artifact);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (values) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        await uploadImage(values, pictureAttributeNames, 'artifacts');
        dispatch(updateArtifactApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showArtifactApi({ navigate, id }));

        return () => dispatch(clearEditedArtifact());
    }, []);

    return (
        <ArtifactForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default ArtifactUpdate;
